import TutorialsMixin from '@/mixins/TutorialsMixin';
import ProductType from '@/statics/productType';
import { isValid, parseISO, endOfDay, startOfDay } from 'date-fns';

export const infoDialogStorage = 'user-information';

export default {
  mixins: [TutorialsMixin],

  computed: {
    infoDialogs() {
      /**
       * @type {object[]}
       * array of config objects with following properties
       * @property {String} key - unique key used to save confirmation in local storage
       * @property {String} title - card title
       * @property {String} text - card text
       * @property {Boolean} isAlert - whether to show error icon in title
       * @property {Number} startDate  - date in format yyyy-MM-dd (or with specific hour/minute: yyyy-MM-ddThh:mm+02:00 in summer or +01:00 in winter time), first day to show dialog
       * @property {Number} endDate - date in format yyyy-MM-dd (or with specific hour/minute: yyyy-MM-ddThh:mm+02:00 in summer or +01:00 in winter time), last day to show dialog
       * @property {Boolean} condition - set to false if dialog should not be displayed
       */
      return [
        {
          key: '2026-10-12-finnya-rebranding',
          title: 'Aus TeamFaktor&nbsp;NW&nbsp;GmbH wird Finnya&nbsp;Factoring&nbsp;GmbH',
          text: `Die <b>TeamFaktor&nbsp;NW&nbsp;GmbH</b> firmiert künftig als <b>Finnya&nbsp;Factoring&nbsp;GmbH</b>.

            Die technische und operative Umstellung erfolgt in den nächsten 6 bis 8 Wochen. In dieser Übergangszeit können Ihnen daher beide Firmierungen begegnen.

            Für Sie bleibt die Zusammenarbeit unverändert. Insbesondere ergeben sich keine Änderungen an den bestehenden Vertragsverhältnissen und getroffenen Abreden.

            Bitte stellen Sie sicher, dass künftig der neue Firmenname auf Ihren Rechnungen und ggf. in Ihren Abtretungsvermerken angegeben ist.

            Vielen Dank für Ihr Vertrauen. Wir freuen uns auf die weitere Zusammenarbeit.

            <b>Ihre Finnya&nbsp;Factoring&nbsp;GmbH</b><br/>
            <i>(vormals TeamFaktor&nbsp;NW&nbsp;GmbH)</i><br/><br/>
            <img alt="" src="${require('@/assets/Finnya-logo.svg')}" width="200" />`,
          startDate: '2026-10-12',
          endDate: '2026-11-30',
          condition: [ProductType.DV_FACTORING, ProductType.FW_FACTORING].includes(
            this.$auth.user()?.product
          )
        },
        {
          key: '2026-11-05-e-invoice-obligation',
          title: 'E-Rechnungspflicht ab 2027: Sind Sie vorbereitet?',
          text: `Sie erstellen Ihre Rechnungen noch mit Word oder Excel? Oder fragen Sie sich, ob eine PDF-Rechnung ausreicht? Dann ist es Zeit, auf eine Software zur Erstellung von E-Rechnungen umzustellen.

            Ab dem 1.&nbsp;Januar&nbsp;2027 müssen Unternehmen mit einem <b>Vorjahresumsatz von mehr als 800.000&nbsp;Euro</b> für inländische B2B-Umsätze grundsätzlich E-Rechnungen ausstellen.

            Bei Fragen zur E-Rechnung wenden Sie sich bitte an Ihren Steuerberater.

            Im Portal können Sie bereits jetzt elektronische Rechnungen im ZUGFeRD-Format oder im XRechnung-Format über die Upload-Funktion oder per API hochladen und bequem per E-Mail an Ihre Firmenkunden versenden. Die Zustellung erfolgt direkt aus dem Portal an die E-Mail-Adresse des Empfängers. Damit erfüllen Sie auch künftig die gesetzlichen Anforderungen.

            Ihr Kundenservice`,
          startDate: '2026-11-05',
          endDate: '2026-12-31'
        }
      ];
    },
    activeInfoDialogs() {
      return this.infoDialogs.filter((dialog) => {
        const hasFulfilledCondition = this.hasFulfilledCondition(dialog);

        const startDateIsInPast =
          !dialog.startDate ||
          (isValid(parseISO(dialog.startDate)) &&
            (dialog.startDate.length > 10
              ? Date.parse(dialog.startDate)
              : startOfDay(Date.parse(dialog.startDate))) < Date.now());

        const endDateIsInFuture =
          !dialog.endDate ||
          (isValid(parseISO(dialog.endDate)) &&
            (dialog.endDate.length > 10
              ? Date.parse(dialog.endDate)
              : endOfDay(Date.parse(dialog.endDate))) > Date.now());

        return hasFulfilledCondition && startDateIsInPast && endDateIsInFuture;
      });
    }
  }
};
